import "@postenbring/hedwig-css/dist/tokens.css";
import "@postenbring/hedwig-css/dist/warning-banner.css";

import { WarningBanner } from "@postenbring/hedwig-react";
import { FC, useEffect, useState } from "react";

import Translated from "../infrastructure/Translated";
import { getStatusPageData, StatusPageInfo } from "./statuspageApiClient";

const StatusPageBanner: FC = () => {
  const [statusPageInfo, setStatusPageInfo] = useState<StatusPageInfo[]>([]);

  useEffect(() => {
    getStatusPageData().then(setStatusPageInfo);
  }, []);

  if (!statusPageInfo.length) {
    return null;
  }

  if (statusPageInfo.length > 1) {
    return (
      <WarningBanner
        title={
          <>
            <Translated textKey={"downtime.multiple"} /> -{" "}
            <a href={"https://status.digipost.no"}>
              <Translated textKey={"downtime.read_more"} />
            </a>
          </>
        }
      />
    );
  }

  const incident = statusPageInfo[0];

  if (incident.type === "scheduled_maintenance")
    return (
      <WarningBanner
        title={
          <>
            {incident.maintenanceDate} - {incident.maintenanceEndDate}:{" "}
            {incident.name} -{" "}
            <a href={incident.shortlink}>
              <Translated textKey={"downtime.read_more"} />
            </a>
          </>
        }
      />
    );

  return (
    <WarningBanner
      title={
        <>
          {incident.name} -{" "}
          <a href={incident.shortlink}>
            <Translated textKey={"downtime.read_more"} />
          </a>
        </>
      }
    />
  );
};

export default StatusPageBanner;
